import { z } from 'zod';
export const PDF_LAYOUT_VALUES = [
    'standard',
    'compact',
    'pratt',
    'serolinix',
    'sister-pierre',
    'biolab-requisition',
    'biolab-biological',
    'alta',
    'biolab-generic',
];
export const pdfLayoutSchema = z.enum(PDF_LAYOUT_VALUES);
export const labClientPdfTemplateSchema = z
    .object({
    layout: pdfLayoutSchema.default('standard'),
    headerLogoStorageRef: z.string().max(500).optional().nullable(),
    headerFields: z.array(z.string().max(100)).max(20).optional(),
    footerText: z.string().max(1000).optional(),
    complianceFields: z
        .object({
        clia: z.boolean().default(true),
        npi: z.boolean().default(true),
        labDirector: z.boolean().default(true),
    })
        .optional(),
    accentColor: z
        .string()
        .regex(/^#[0-9a-f]{6}$/i, 'accentColor must be a #rrggbb hex string')
        .optional(),
    pageSize: z.enum(['letter', 'a4']).default('letter').optional(),
    margins: z
        .object({
        top: z.number().min(0).max(200).optional(),
        right: z.number().min(0).max(200).optional(),
        bottom: z.number().min(0).max(200).optional(),
        left: z.number().min(0).max(200).optional(),
    })
        .optional(),
    // §7.6.21 Slice 4 -- requisition template toggles (legacy LAB_TEMPLATE_MAP /
    // LABS_ORDER_REQ / LABS_FOR_SEPARATE_TESTS per-client behavior). All
    // optional with defaults so rows stored before this slice still parse
    // unchanged. Consumed by `services/pdf/renderers/biolab-requisition.ts`
    // and `services/pdf/dispatcher.ts` -- see those files for applicability.
    //
    // NOTE: `.default(x).optional()` (matching the pre-existing `pageSize`
    // field above) keeps the *type* optional so the many pre-existing
    // `LabClientPdfTemplate` object literals across the renderer test suite
    // (e.g. `{ layout: 'alta' }`) keep type-checking without every fixture
    // needing all 5 new keys. The tradeoff: chaining `.optional()` after
    // `.default()` makes ZodOptional short-circuit on `undefined` *before*
    // the inner ZodDefault runs, so `.safeParse({})` yields `undefined` for
    // these fields, not the literal default (the flip side of the
    // `defaultResultStatus`-stripping class of bug fixed immediately prior
    // to this slice -- there the default was stripped by a wrapper; here
    // it's never applied by design of the chain order). This is safe here
    // because every consumer (dispatcher.ts, biolab-requisition.ts) reads
    // these fields through `?? default` / truthy checks, never assumes the
    // schema pre-fills them -- see lab-client-pdf-template.test.ts for the
    // documented actual behavior.
    includeEligibilityQuestion: z.boolean().default(false).optional(),
    includePresumptivePanel: z.boolean().default(false).optional(),
    separateTestsOnReq: z.boolean().default(false).optional(),
    reqTestSelectionMode: z.enum(['ordered_only', 'all']).default('all').optional(),
    reqEnabled: z.boolean().default(true).optional(),
})
    .strict();
//# sourceMappingURL=lab-client-pdf-template.js.map